export const menu = [
  {
    "type": 'header',
    "href": '#',
    "icon": '',
    "entity": '',
    "label": 'Pagine',
    "hideForLevel" : [2],
  },
  {
    "type": 'item',
    "href": '/',
    "icon": 'home',
    "entity": '',
    "label": 'Dashboard',
    "hideForLevel" : [2],
  },
  {
    "type": 'item',
    "href": '/page/ticketMap',
    "icon": 'map',
    "entity": '',
    "label": 'Mappa',
    "hideForLevel" : [2],
  },
  {
    "type": 'folder',
    "href": '#',
    "icon": 'lightbulb',
    "entity": '',
    "label": 'Segnalazioni',
    "hideForLevel" : [2],
    "items": [
      {
        "type": 'item',
        "href": '/entity/ticket',
        "entity": 'ticket',
        "label": 'Tutte le Segnalazioni'
      },
      {
        "type": 'item',
        "href": '/entity/gyv_ticket_open',
        "entity": 'gyv_ticket_open',
        "label": 'Segnalazioni Aperte'
      },
      {
        "type": 'item',
        "href": '/entity/gyv_ticket_in_progress',
        "entity": 'gyv_ticket_in_progress',
        "label": 'Segnalazioni In Gestione'
      },
      {
        "type": 'item',
        "href": '/entity/gyv_ticket_closed',
        "entity": 'gyv_ticket_closed',
        "label": 'Segnalazioni Chiuse'
      }
    ]
  },
  
  //hide this menu if user level higher than 1

  {
    "type": 'header',
    "href": '#',
    "icon": '',
    "entity": '',
    "label": 'Amministrazione',
    "hideForLevel" : [1 , 2]
  },
  {
    "type": 'item',
    "href": '/entity/gyv_user_authority',
    "icon": 'user',
    "entity": 'gyv_user_authority',
    "label": 'Utenze Comuni',
    "hideForLevel" : [1 , 2]
  },
  {
    "type": 'item',
    "href": '/entity/user_group',
    "icon": 'shield-halved',
    "entity": 'user_group',
    "label": 'Comuni',
    "hideForLevel" : [1 , 2]
  },
  {
    "type": 'item',
    "href": '/entity/category',
    "icon": 'list',
    "entity": 'category',
    "label": 'Categorie',
    "hideForLevel" : [1 , 2]
  },
  {
    "type": 'item',
    "href": '/entity/user',
    "icon": 'user',
    "entity": 'user',
    "label": 'Tutti gli Utenti',
    "hideForLevel" : [1 , 2]
  },

  // visibile for all

  {
    "type": 'header',
    "href": '#',
    "icon": '',
    "entity": '',
    "label": 'Utente'
  },
  {
    "type": 'item',
    "href": '/settings',
    "icon": 'user-gear',
    "entity": '',
    "label": 'Profilo'
  },
  {
    "type": 'folder',
    "href": '#',
    "icon": 'cogs',
    "entity": '',
    "label": 'Impostazioni',
    "items": [
      {
        "type": 'item',
        "href": '/entity/user_entity_saved_filters',
        "entity": 'user_entity_saved_filters',
        "label": 'Filtri salvati'
      },
      {
        "type": 'item',
        "href": '/entity/user_entity_preferences',
        "entity": 'user_entity_preferences',
        "label": 'Preferenze entità'
      },
      {
        "type": 'item',
        "href": '/entity/log',
        "entity": 'log',
        "label": 'Log'
      }
    ]
  },
  {
    "type": 'item',
    "href": '/logout',
    "icon": 'arrow-right-from-bracket',
    "entity": '',
    "label": 'Logout'
  }
];
